export const COUNTRIES = [
  'Nigeria',
  'United States',
  'United Kingdom',
  'Australia',
  'Canada',
  'Germany',
  'Singapore',
  'South Africa',
  'Kenya',
  'India',
  'UAE',
  'Other',
]

export const INDUSTRIES = [
  'Technology / SaaS',
  'Financial Services',
  'Healthcare',
  'Retail & E-commerce',
  'Logistics & Transport',
  'Construction',
  'Agriculture',
  'Manufacturing',
  'Education',
  'Other',
]

export const CURRENCIES = {
  Nigeria: { code: 'NGN', symbol: '₦' },
  'United States': { code: 'USD', symbol: '$' },
  'United Kingdom': { code: 'GBP', symbol: '£' },
  Australia: { code: 'AUD', symbol: 'A$' },
  Canada: { code: 'CAD', symbol: 'C$' },
  Germany: { code: 'EUR', symbol: '€' },
  Singapore: { code: 'SGD', symbol: 'S$' },
  'South Africa': { code: 'ZAR', symbol: 'R' },
  Kenya: { code: 'KES', symbol: 'KSh' },
  India: { code: 'INR', symbol: '₹' },
  UAE: { code: 'AED', symbol: 'د.إ' },
  Other: { code: 'USD', symbol: '$' },
}

export const ALL_CURRENCIES = [
  { code: 'NGN', symbol: '₦' },
  { code: 'USD', symbol: '$' },
  { code: 'GBP', symbol: '£' },
  { code: 'AUD', symbol: 'A$' },
  { code: 'CAD', symbol: 'C$' },
  { code: 'EUR', symbol: '€' },
  { code: 'SGD', symbol: 'S$' },
  { code: 'ZAR', symbol: 'R' },
  { code: 'KES', symbol: 'KSh' },
  { code: 'INR', symbol: '₹' },
  { code: 'AED', symbol: 'د.إ' },
]

export function getDefaultCurrency(country) {
  return CURRENCIES[country] || CURRENCIES.Other
}

export function getCurrencyByCode(code) {
  return ALL_CURRENCIES.find((c) => c.code === code) || ALL_CURRENCIES[0]
}

export const ID_TYPES = {
  Nigeria: ['NIN', "Driver's License", 'International Passport', 'Voter Card'],
  'United States': ["Driver's License", 'US Passport', 'State ID', 'Permanent Resident Card'],
  'United Kingdom': ['Passport', "Driver's License", 'Biometric Residence Permit'],
  Australia: ['Passport', "Driver's License", 'Medicare Card'],
  Canada: ['Passport', "Driver's License", 'PR Card'],
  Germany: ['Passport', 'Personalausweis (ID Card)', 'Residence Permit'],
  Singapore: ['NRIC', 'Passport', 'Employment Pass'],
  'South Africa': ['ID Document', 'Passport'],
  Kenya: ['National ID', 'Passport'],
  India: ['Aadhaar', 'PAN Card', 'Passport'],
  UAE: ['Emirates ID', 'Passport'],
  Other: ['Passport', "Driver's License"],
}

export const LABEL_SETS = {
  Nigeria: { rc: 'RC Number', cac: 'CAC Certificate', tin: 'TIN Letter', scuml: 'SCUML Certificate' },
  'United States': { rc: 'EIN', cac: 'Articles of Incorporation', tin: 'IRS Letter', scuml: 'FinCEN Registration' },
  'United Kingdom': { rc: 'CRN', cac: 'Companies House Filing', tin: 'UTR', scuml: 'HMRC AML Registration' },
  Australia: { rc: 'ABN', cac: 'Certificate of Registration', tin: 'Tax Notice', scuml: 'Financial Authority Registration' },
  Canada: { rc: 'BN', cac: 'Articles of Incorporation', tin: 'CRA Notice', scuml: 'FINTRAC Registration' },
  Germany: { rc: 'HRB Number', cac: 'Handelsregister Extract', tin: 'Steuernummer', scuml: 'BaFin Registration' },
  Singapore: { rc: 'UEN', cac: 'BizFile Profile', tin: 'IRAS Notice', scuml: 'MAS AML Registration' },
  'South Africa': { rc: 'CIPC Number', cac: 'CIPC Certificate', tin: 'SARS Letter', scuml: 'FIC Registration' },
  Kenya: { rc: 'CR Number', cac: 'Certificate of Incorporation', tin: 'KRA PIN', scuml: 'COMRA Registration' },
  India: { rc: 'CIN', cac: 'Certificate of Incorporation', tin: 'PAN Card', scuml: 'MCA Filing' },
  UAE: { rc: 'Trade License', cac: 'MOA', tin: 'TRN', scuml: 'CDD Registration' },
  Other: { rc: 'Registration Number', cac: 'Certificate of Incorporation', tin: 'Tax ID', scuml: 'AML Registration' },
}

export function getLocalizedLabels(country) {
  const key = LABEL_SETS[country] ? country : 'Other'
  const labels = LABEL_SETS[key]
  return [
    { id: 'rc', label: labels.rc, value: '', status: 'pending' },
    { id: 'cac', label: labels.cac, value: '', status: 'pending' },
    { id: 'tin', label: labels.tin, value: '', status: 'pending' },
    { id: 'scuml', label: labels.scuml, value: '', status: 'pending' },
  ]
}
